package ui.campaign.detailv2.widgets

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import common.frontend.api.Io
import compose.assets.Svg
import compose.assets.svg.Chevron_right
import compose.assets.svg.Link_variant
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_top_detail_editor__page_offsets
import tk.mallumo.compose.navigation.navTo_CampaignPreviewUI
import tools.rememberString
import ui.campaign.detailv2.preview.CampaignPreviewArgs
import ui.campaign.detailv2.preview.CampaignPreviewScope

@Composable
fun CampaignPreviewScope.CardOffsets(nnvl: CampaignPreviewScope.Wrapper) {
    nnvl.data.otherCampaignGroups.filter { it.exclude }
        .takeIf { it.isNotEmpty() }
        ?.also { items ->

            CampaignCardOffsets(items) {
                nav.navTo_CampaignPreviewUI(
                    CampaignPreviewArgs(
                        companyId = args.companyId,
                        campaignGroupId = it
                    )
                )
            }
        }
}

@Composable
fun CampaignCardOffsets(
    excludedCampaigns: List<Io.Campaign.OtherCampaignGroup>,
    onClick: ((id: Long) -> Unit)? = null
) {
    CampaignInfoCardWrapper(
        icon = Svg.Link_variant,
        label = Res.string.layer_top_detail_editor__page_offsets.rememberString(),
    ) {
        excludedCampaigns.forEachIndexed { index, item ->
            if (index != 0) HorizontalDivider()

            Row(
                modifier = Modifier
                    .clip(CardDefaults.shape)
                    .clickable(onClick != null) {
                        onClick?.invoke(item.id)
                    }.padding(vertical = 4.dp)
            ) {
                Text(
                    text = item.name,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.padding(horizontal = 8.dp).weight(1F)
                )
                onClick?.run {
                    Icon(
                        imageVector = Svg.Chevron_right,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            }
        }
    }
}